module.exports = __webpack_public_path__ + "static/img/采购商.5c5e302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/采购商.png
// module id = sOQY
// module chunks = 184